module.exports = __webpack_public_path__ + "static/media/7-kvart.e0fb1f15.mp3";